import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TitleSteps = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom?.grey?.dark,
  lineHeight: "1.5rem",
  marginBottom: theme.spacing(2),
}));
